/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Creem_DescriptionInputs */

const en_admin_settings_groups_creem_description = /** @type {(inputs: Admin_Settings_Groups_Creem_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creem payment gateway`)
};

/**
* | output |
* | --- |
* | "Creem payment gateway" |
*
* @param {Admin_Settings_Groups_Creem_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_creem_description = /** @type {((inputs?: Admin_Settings_Groups_Creem_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Creem_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_creem_description(inputs)
});
export { admin_settings_groups_creem_description as "admin.settings.groups.creem.description" }